import { call, put, takeLatest, takeEvery, select } from "redux-saga/effects";
import { logOut } from "../login/action";
import * as QueryParams from "query-string";
import { callApi, callApiWithNoAuth, Method, request } from "../../api/Api";
import { getConfig } from "../../services/environment";
import {
  stopLoading,
  showErrorMessage,
  startLoading,
} from "../layout/action";
import { GET_CIATATION_PDF_STATES_UNPAID, setDriverCitationPDFStates } from "./action";
import { GET_CIATATION_PDF_STATES } from "./action";

export function* callGetDriverCitationPDFStates(action) {
  
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApiWithNoAuth, {
      responseType: "arraybuffer",
      method: "GET",
      // url: `/citation-actions/download-citation/${action.payload.citationId}`,
      url: `/portal/pages/home-without-session/download-citation/${action.payload.citationId}`,
    });

    const { data } = stateResponse;
    const file = new Blob([stateResponse.data], { type: "application/pdf" });
    const url = URL.createObjectURL(file);
    window.open(url);

    yield put(setDriverCitationPDFStates(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Get citation pdf list" }));
  }
}

export function* watchGetDriverCitationPDFStates() {
  yield takeEvery(GET_CIATATION_PDF_STATES, callGetDriverCitationPDFStates);
}

export function* callGetDriverCitationPDFStatesUnpaid(action) {
  
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      responseType: "arraybuffer",
      method: "GET",
      url: `/citation-actions/download-payment-receipt/${action.payload.citationId}`,
    });

    const { data } = stateResponse;
    const file = new Blob([stateResponse.data], { type: "application/pdf" });
    const url = URL.createObjectURL(file);
    window.open(url);

    yield put(setDriverCitationPDFStates(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Get citation pdf list" }));
  }
}

export function* watchGetDriverCitationPDFStatesUnpaid() {
  yield takeEvery(GET_CIATATION_PDF_STATES_UNPAID, callGetDriverCitationPDFStatesUnpaid);
}

